module.exports = __webpack_public_path__ + "6dc50447de5af6b26fd3dbb59935c272.png";